const additionalSearchFilterHelpers = {
	getAdditionalFilterValuesFromDom: function() {
		const $additionalFilters = rp$('.additional-filter-form');
		const parsedFilters = {};

		$additionalFilters.children().each((i, filter) => {
			if (filter.classList.contains('select-filter-wrapper')) {
				const select = rp$(filter).find('select');
				const selectedValue = select.val();
				parsedFilters[select[0].getAttribute('data-query-name')] = selectedValue;
			}
		});

		return parsedFilters;
	}

};

module.exports = additionalSearchFilterHelpers;
